// standard vite option is wrong in vercel
import { getPassword } from "../modules/auth"

export const IS_PROD = import.meta.env.VITE_IS_VERCEL === "true"
export const IS_DEBUG = import.meta.env.VITE_IS_DEBUG === "true"
export const E2E_TEST = import.meta.env.VITE_E2E_TEST === "true"
// When ON, the /sortaballs route swaps its puzzle data for the tiny
// e2e-puzzles/sortaballs-10-colors.json fixture (a 10-move board) so e2e can
// assert the exact move the success animation fires at.
export const E2E_SORTABALLS = import.meta.env.VITE_E2E_SORTABALLS === "ON"
export const EXPERIMENTAL_ANIMATIONS =
  import.meta.env.VITE_EXPERIMENTAL_ANIMATIONS !== "false"
export const ON = "ON"
export const OFF = "OFF"
export const TICK_TIMEOUT = 100

export const BOOKMARKS_EXPORT_WEBHOOK =
  import.meta.env.VITE_BOOKMARKS_WEBHOOK_URL ?? ""
export const SERVER_URL =
  import.meta.env.VITE_SERVER_URL ??
  "https://learn-smarter-server-api.onrender.com"
export const VERCEL_SERVER_URL =
  import.meta.env.VITE_VERCEL_SERVER_URL ?? "https://lambdas-fn.vercel.app"

export const IS_LOGGED = "is-logged-key"
export const USER_NAME = "user-name-key"
export const isLogged = localStorage.getItem(IS_LOGGED) === "ON"
export const password = getPassword()
export const WHEN = !!password || !IS_PROD

/**
 * https://github.com/JamesBrill/react-speech-recognition/blob/HEAD/docs/API.md#language-string
 */
export const MIC_LANGUAGES: Record<Language, LanguageMicInput> = {
  bulgarian: "bg-BG",
  finnish: "fi-FI",
  french: "fr-FR",
  german: "de-DE",
  greek: "el-GR",
  italian: "it-IT",
  portuguese: "pt-PT",
  spanish: "es-ES",
}
